import {Injectable} from '@angular/core';
// @ts-ignore
import {JwtService, MclaneWebauthLibService} from 'mclane-webauth-lib';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '~/environments/environment';
import {LoggingService} from "mclane-apptemplate-lib";

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private readonly baseUrl: string;
  private defaultHeaders: HttpHeaders;

  constructor(public  keycloakService: MclaneWebauthLibService, public httpClient: HttpClient, public jwtService: JwtService, public console: LoggingService) {
    this.baseUrl = environment.supportServicePrefix;
    this.defaultHeaders = new HttpHeaders().append('X-Requested-With', 'XmlHttpRequest').append('Content-Type', 'application/json');
  }


  getClients() {
    return this.httpClient.get(`${this.baseUrl}/keycloak/clients`,  {headers: this.defaultHeaders});
  }
  getUserRoles(result: object) {
    const currentAccessItemsForUser = [];
    let totalAvailClients: any[];
    const list = Object.values(result);
    totalAvailClients = list;
    const resources = this.jwtService.getJwtAttribute('resource_access');


    const userAccessClients = Object.entries(resources);
    for (let count = 0; count < userAccessClients.length; count++) {

      const userCheckItem = userAccessClients[count];
      const originalName = userCheckItem[0];
      const comparable = this.createComparableString(userCheckItem[0]).replace(/,/g, ' ');
      const clientItem = totalAvailClients.find((item) => item.name.toLowerCase() === comparable);
      if ( clientItem  != null) {
        clientItem.originalName = originalName;
        currentAccessItemsForUser.push(clientItem);
      }
    }
    return currentAccessItemsForUser;

  }

   public createComparableString(userCheckItem: string) {
    const string = userCheckItem.toString().split('-');
    const removefs = string.filter((result) => result !== 'fs');
     return removefs.toString();
  }
}
